/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const EMAIL_LIST = 'EMAIL_LIST';
export const EMAIL_LOG_DETAIL = 'EMAIL_LOG_DETAIL';
export const EMAIL_LOG_RIGHT_GRID = 'EMAIL_LOG_RIGHT_GRID';
export const SAVE_EMAIL_LOG = 'SAVE_EMAIL_LOG';
export const ERROR_LEFT_RIGHT_GRID = 'ERROR_LEFT_RIGHT_GRID';
export const EMAIL_AVAILABLE_LIST = 'EMAIL_AVAILABLE_LIST';
export const EMAIL_LIST_CHECK = 'EMAIL_LIST_CHECK';
export const SAVE_PAYLOAD_LIST = 'SAVE_PAYLOAD_LIST';
export const DELETE_PAYLOAD_LIST = 'DELETE_PAYLOAD_LIST';
